import { Box } from "@chakra-ui/react"
import { RouteProvider } from "@hydrologiq/shared/providers/RouteProvider"
import { ReactNode } from "react"

function NoAuth({ children }: { children: ReactNode }) {
  return (
    <Box fontFamily={"montserrat !important"}>
      <RouteProvider>{children} </RouteProvider>
    </Box>
  )
}

export default NoAuth
